export enum XrmGridType {
    HomePageGrid = 1,
    Subgrid = 2
}